import { render, staticRenderFns } from "./AssistHistoryCard.vue?vue&type=template&id=d64ad326&scoped=true"
import script from "./AssistHistoryCard.vue?vue&type=script&lang=ts"
export * from "./AssistHistoryCard.vue?vue&type=script&lang=ts"
import style0 from "./AssistHistoryCard.vue?vue&type=style&index=0&id=d64ad326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64ad326",
  null
  
)

export default component.exports